import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CurrentTenantService } from '@suvo-bi-users';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginComponentOptions = {
    titleText: 'Login',
    hideChildTitles: true,
    // showRegister: true
  };

  showRegister = true;

  loginStatus;
  passwordResetStatus;
  mode: 'login' | 'forgot-password' = 'login';
  freeTrial = 30;

  constructor(
    private route: ActivatedRoute,
    private currentTenantService: CurrentTenantService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((p) => {
      if (p.forgotPassword) {
        this.mode = 'forgot-password';

        this.loginComponentOptions.titleText = 'Forgot password';
      } else {
        this.mode = 'login';

        this.loginComponentOptions.titleText = 'Login';
      }

      this.loginStatus = null;
      this.passwordResetStatus = null;
    });
    this.freeTrial = this.currentTenantService.currentTenantData.autoTrialPeriod;
  }

  onLoginStatusChange(status) {
    console.log('Login status: ', status);
    this.loginStatus = status;
  }

  onResetPasswordStatusChange(status) {
    console.log('Password Reset status: ', status);
    this.passwordResetStatus = status;
  }
}
